const sort = (object: object) => {
    const ordered: object = {}

    Object.keys(object).sort().forEach((key: any) => {
        // @ts-ignore
        ordered[key] = object[key]
    })

    return ordered
}

const reverseSort = (a: any, b: any): number => {
    return b - a
}

export const sortReverse = (object: object) => {
    const ordered: object = {}

    Object.keys(object).sort(reverseSort).forEach((key: any) => {
        // @ts-ignore
        ordered[key] = object[key]
    })

    return ordered
}

export const toArray = (object: object) => {
    return Object.keys(object).sort().map((key: any) => {
        // @ts-ignore
        return object[key]
    })
}

export const toReverseArray = (object: object) => {
    return Object.keys(object).sort(reverseSort).map((key: any) => {
        // @ts-ignore
        return object[key]
    })
}

export default sort
